import { hydrate } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

import { App } from "./app";
import { rememberArrival } from "./lib/attribution";
import { createAppRouter, createQueryClient } from "./lib/router";
import { STATE_ELEMENT_ID } from "./lib/ssr-state";

import "./styles.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

// Outside React: the referrer and the utm link describe the page load, not a render.
rememberArrival();

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);
const app = (
  <StrictMode>
    <App queryClient={queryClient} router={router} />
  </StrictMode>
);

const serverState = document.getElementById(STATE_ELEMENT_ID);
if (serverState?.textContent) {
  // The server rendered this page. Its query cache comes along, so the loaders below find
  // their data instead of fetching it again, and the first render matches the HTML. The
  // route's code chunk is loaded before hydrating for the same reason.
  hydrate(queryClient, JSON.parse(serverState.textContent));
  // Tells the router the page came from the server. Without it, the browser wraps the
  // matches in one more Suspense boundary than the server rendered, and hydration fails.
  router.ssr = { manifest: undefined };
  void router.load().then(() => hydrateRoot(rootElement, app));
} else {
  createRoot(rootElement).render(app);
}
